export const rewardPointsDisplayTranslations = {
  "en-US": {
    label_one: "Point",
    label_other: "Points",
  },
};

export default rewardPointsDisplayTranslations;
